import React, { Component } from "react";
import bkg from "../assets/images/frame-bkg.svg";
import logo from "../assets/images/logo.png";

export default class NotFound extends Component {
    render() {
        return (
            <div className="right_side_wrapper">
                <div className="container text_center">
                    {/* <header>
                        <div className="logo">
                            <img src={logo} />
                        </div>
                        <div className="title">
                            <h1>SUNDANCE FILM FESTIVAL - Digital CMS</h1>
                        </div>
                        <div className="support_link">
                            <a href="mailto:sff21@sundance.org" target="_blank" >Contact Support</a>
                        </div>
                    </header> */}
                    <div className="sundance_wrapper">
                        <div className="background">
                        <img src={'https://d2wsrejhnxatgp.cloudfront.net/assest/common/CMS_Background.png'} />
                        </div>
                        <div className="notfound d_flex relative d_flex_justify_center d_flex_align_center">
                            <div className="inner_nocontent">
                                <h1>404</h1>
                                <h2>We couldn’t find this page!</h2>
                            </div>
                        </div>
                    </div>
                    
                </div>
            </div>
        )
    }
}
